import { computed, PropType, defineComponent } from 'vue';
import renderFn from '../utils/render-fn';
import {
  IconProps, SVGJson,
} from '../utils/types';
import useSizeProps from '../utils/use-size-props';

import '../style/css';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"zoom-out"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15.8033 15.8033C12.8744 18.7322 8.12563 18.7322 5.1967 15.8033C2.26777 12.8744 2.26777 8.12563 5.1967 5.1967C8.12563 2.26777 12.8744 2.26777 15.8033 5.1967C18.7322 8.12563 18.7322 12.8744 15.8033 15.8033Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.8033 15.8033C12.8744 18.7322 8.12563 18.7322 5.1967 15.8033C2.26777 12.8744 2.26777 8.12563 5.1967 5.1967C8.12563 2.26777 12.8744 2.26777 15.8033 5.1967C18.7322 8.12563 18.7322 12.8744 15.8033 15.8033ZM15.8033 15.8033L21.1066 21.1066","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.5 10.5H10.5L13.5 10.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

export default defineComponent({
  name: 'ZoomOutIcon',
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [Array, String] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [Array, String] as PropType<IconProps['strokeColor']>,
    },
    strokeWidth: {
      type: Number as PropType<IconProps['strokeWidth']>,
    }
  },
  setup(props, { attrs }) {
    const propsSize = computed(() => props.size);

    const strokeColor1 = computed(() => {
      if (!props.strokeColor) return 'currentColor';
      return Array.isArray(props.strokeColor) ? props.strokeColor[0] : props.strokeColor
    })
    const strokeColor2 = computed(() => {
      if (!props.strokeColor) return 'currentColor';
      return Array.isArray(props.strokeColor) ? props.strokeColor[1] ?? props.strokeColor[0] : props.strokeColor
    })

    const fillColor1 = computed(() => {
      if (!props.fillColor) return 'transparent';
      return Array.isArray(props.fillColor) ? props.fillColor[0] : props.fillColor
    })
    const fillColor2 = computed(() => {
      if (!props.fillColor) return 'transparent';
      return Array.isArray(props.fillColor) ? props.fillColor[1] ?? props.fillColor[0] : props.fillColor
    })

    // 填充类型图标
    const filledColor = computed(() => {
      if (!props.fillColor) return 'currentColor';
      return Array.isArray(props.fillColor) ? props.fillColor[0] : props.fillColor;
    })


    const { className, style } = useSizeProps(propsSize);

    const finalCls = computed(() => ['t-icon', 't-icon-zoom-out', className.value]);
    // fill none 是为了避免存在旧版本图标的 fill:currentColor 造成的样式污染
    const finalStyle = computed(() => ({ fill: 'none', ...style.value, ...(attrs.style as Styles) }));
    const finalProps = computed(() => ({
      class: finalCls.value,
      style: finalStyle.value,
      onClick: (e: MouseEvent) => props.onClick?.({ e }),
      strokeColor1: strokeColor1.value,
      strokeColor2: strokeColor2.value,
      fillColor1: fillColor1.value,
      fillColor2: fillColor2.value,
      strokeWidth: props.strokeWidth || 2,
      filledColor: filledColor.value
    }));
    return () => renderFn(element, finalProps.value);
  },

});
